export default function normalizeStoryblokSeo(
  seoMeta: SeoMetaInfoStoryblok,
  {
    fallbackImage,
  }: {
    fallbackImage?: string | null;
  } = {},
) {
  return {
    title: seoMeta?.title || '',
    description: seoMeta?.metaDescription || '',
    image: seoMeta?.metaImage?.filename || fallbackImage || '',
  };
}
